import { IMilestone } from "./Milestone";
import { IReportingProgressUpdateWithDeliveryDates, ReportingProgressUpdateWithDeliveryDates } from "./ReportingProgressUpdate";

export interface IMilestoneUpdate extends IReportingProgressUpdateWithDeliveryDates {
    MilestoneID: number | null;
    Milestone?: IMilestone;
}

export class MilestoneUpdate extends ReportingProgressUpdateWithDeliveryDates implements IMilestoneUpdate {
    public MilestoneID: number | null = null;

    constructor(milestoneId: number, period?: Date) {
        super(period);
        this.MilestoneID = milestoneId;
    }
}